import React from "react";
import _pubA97D53F3 from "./atoms.pc";
import _pubBab5A68F, {Preview as _pubBab5A68F_Preview} from "./utils.pc";
import "./Button.pc.css";
function getDefault(module) {
  return module.default || module;
}

function castStyle(value) {
  var tov = typeof value;
  if (tov === "object" || tov !== "string" || !value) return value;
  return value.trim().split(";").reduce(function (obj, keyValue) {
    var kvp = keyValue.split(":");
    var key = kvp[0];
    var value = kvp[1];
    if (!value || value === "undefined") return obj;
    var trimmedValue = value.trim();
    if (trimmedValue === "undefined" || !trimmedValue) return obj;
    obj[key.trim()] = trimmedValue;
    return obj;
  }, {});
}

export const classNames = {

};

var $$Default = React.memo(React.forwardRef(function $$Default(props, ref) {
  return React.createElement(props.tagName || "button", {
    "className": "_49f0af9a _2dbb4493 _pub-2dbb4493 _pub-a97d53f3" + " " + "_2dbb4493_v3 _pub-2dbb4493_v3 _pub-a97d53f3_v3 v3 _2dbb4493_hum _pub-2dbb4493_hum _pub-a97d53f3_hum hum _2dbb4493_dark _pub-2dbb4493_dark _pub-a97d53f3_dark dark _2dbb4493_theme _pub-2dbb4493_theme _pub-a97d53f3_theme theme _2dbb4493__button _pub-2dbb4493__button _pub-a97d53f3__button _button " + (props["class"] ? " " + props["class"] : "") + " " + " " + (props["className"] ? " " + props["className"] : "") + (props["small"] ? " " + "_2dbb4493__button-small _pub-2dbb4493__button-small _pub-a97d53f3__button-small _button-small" : "") + (props["xsmall"] ? " " + "_2dbb4493__button-xsmall _pub-2dbb4493__button-xsmall _pub-a97d53f3__button-xsmall _button-xsmall" : "") + (props["medium"] ? " " + "_2dbb4493__button-medium _pub-2dbb4493__button-medium _pub-a97d53f3__button-medium _button-medium" : "") + (props["large"] ? " " + "_2dbb4493__button-large _pub-2dbb4493__button-large _pub-a97d53f3__button-large _button-large _2dbb4493__large _pub-2dbb4493__large _pub-a97d53f3__large _large" : "") + (props["large2"] ? " " + "_2dbb4493__button-large _pub-2dbb4493__button-large _pub-a97d53f3__button-large _button-large _2dbb4493__button-large2 _pub-2dbb4493__button-large2 _pub-a97d53f3__button-large2 _button-large2" : "") + (props["lighter"] ? " " + "_2dbb4493__button-lighter _pub-2dbb4493__button-lighter _pub-a97d53f3__button-lighter _button-lighter" : "") + (props["wide"] ? " " + "_2dbb4493__button-wide _pub-2dbb4493__button-wide _pub-a97d53f3__button-wide _button-wide _2dbb4493__wide _pub-2dbb4493__wide _pub-a97d53f3__wide _wide" : "") + (props["grow"] ? " " + "_2dbb4493__button-grow _pub-2dbb4493__button-grow _pub-a97d53f3__button-grow _button-grow" : "") + (props["negative"] ? " " + "_2dbb4493__button-negative _pub-2dbb4493__button-negative _pub-a97d53f3__button-negative _button-negative _2dbb4493__negative _pub-2dbb4493__negative _pub-a97d53f3__negative _negative" : "") + (props["negative2"] ? " " + "_2dbb4493__button-negative2 _pub-2dbb4493__button-negative2 _pub-a97d53f3__button-negative2 _button-negative2" : "") + (props["secondary"] ? " " + "_2dbb4493_secondary _pub-2dbb4493_secondary _pub-a97d53f3_secondary secondary" : "") + (props["primary"] ? " " + "_2dbb4493__button-primary _pub-2dbb4493__button-primary _pub-a97d53f3__button-primary _button-primary _2dbb4493__primary _pub-2dbb4493__primary _pub-a97d53f3__primary _primary" : "") + (props["outline"] ? " " + "_2dbb4493__button-outline _pub-2dbb4493__button-outline _pub-a97d53f3__button-outline _button-outline" : "") + (props["hover"] ? " " + "_2dbb4493_hover _pub-2dbb4493_hover _pub-a97d53f3_hover hover" : "") + (props["icon"] ? " " + "_2dbb4493_icon _pub-2dbb4493_icon _pub-a97d53f3_icon icon" : "") + (props["focus"] ? " " + "_2dbb4493_focus _pub-2dbb4493_focus _pub-a97d53f3_focus focus" : "") + (props["active"] ? " " + "_2dbb4493_active _pub-2dbb4493_active _pub-a97d53f3_active active" : "") + (props["resetCase"] ? " " + "_2dbb4493__button-resetCase _pub-2dbb4493__button-resetCase _pub-a97d53f3__button-resetCase _button-resetCase" : "") + (props["transparent"] ? " " + "_2dbb4493__button-transparent _pub-2dbb4493__button-transparent _pub-a97d53f3__button-transparent _button-transparent _2dbb4493__transparent _pub-2dbb4493__transparent _pub-a97d53f3__transparent _transparent" : "") + (props["loading"] ? " " + "_2dbb4493__button-loading _pub-2dbb4493__button-loading _pub-a97d53f3__button-loading _button-loading" : "") + (props["v3"] ? " " + "_2dbb4493_v3 _pub-2dbb4493_v3 _pub-a97d53f3_v3 v3 _2dbb4493_secondary _pub-2dbb4493_secondary _pub-a97d53f3_secondary secondary" : "") + (props["noMargin"] ? " " + "_2dbb4493_no-margin _pub-2dbb4493_no-margin _pub-a97d53f3_no-margin no-margin" : "") + (props["disabled"] ? " " + "_2dbb4493_disabled _pub-2dbb4493_disabled _pub-a97d53f3_disabled disabled" : "") + (props["wfull"] ? " " + "_2dbb4493__button-wfull _pub-2dbb4493__button-wfull _pub-a97d53f3__button-wfull _button-wfull" : ""),
    "ref": ref,
    "onClick": props["onClick"],
    "title": props["title"],
    "disabled": props["disabled"],
    "href": props["href"],
    "data-primary": props["primary"],
    "data-testid": props["testId"],
    "style": castStyle(props["style"]),
    "type": props["type"],
  }, 
    props["tooltipText"]&&React.createElement("TooltipContainer", {
      "className": "_4bf654ea _2dbb4493 _pub-2dbb4493 _pub-a97d53f3",
      "inherit": true,
    }, 
      props["children"],
      React.createElement("Tooltip", {
        "className": "_f8ba8d57 _2dbb4493 _pub-2dbb4493 _pub-a97d53f3",
        "center": true,
      }, 
        props["tooltipText"]
      )
    ),
    !props["tooltipText"]&&React.createElement(React.Fragment, {
    }, 
      props["children"]
    )
  )
}));
export default $$Default;

var defaultsPreview = React.memo(React.forwardRef(function defaultsPreview(props, ref) {
  return React.createElement(_pubBab5A68F_Preview, {
    "class": "_a7feceb6 _2dbb4493 _pub-2dbb4493 _pub-a97d53f3" + (props["humDark"] ? " " + "_2dbb4493_hum _pub-2dbb4493_hum _pub-a97d53f3_hum hum" + " " + " " + " " + "_2dbb4493_dark _pub-2dbb4493_dark _pub-a97d53f3_dark dark" + " " + " " + " " + "_2dbb4493_theme _pub-2dbb4493_theme _pub-a97d53f3_theme theme" : ""),
    "ref": ref,
  }, 
    React.createElement($$Default, {
      "class": "_896939cb" + " " + "_button-preview",
    }, 
      "default"
      
    ),
    React.createElement($$Default, {
      "class": "_fe6e095d" + " " + "_2dbb4493__button-preview _pub-2dbb4493__button-preview _pub-a97d53f3__button-preview _button-preview",
      "loading": true,
    }, 
      "\n    default\n    "
      ,
      React.createElement("Spinner", {
        "className": "_46e42df9 _2dbb4493 _pub-2dbb4493 _pub-a97d53f3",
      }, null)
    ),
    React.createElement($$Default, {
      "class": "_676758e7" + " " + "_2dbb4493__button-preview _pub-2dbb4493__button-preview _pub-a97d53f3__button-preview _button-preview",
      "disabled": true,
    }, 
      "default Disabled"
      
    ),
    React.createElement($$Default, {
      "class": "_10606871" + " " + "_2dbb4493__button-preview _pub-2dbb4493__button-preview _pub-a97d53f3__button-preview _button-preview",
      "negative": true,
    }, 
      "Negative"
      
    ),
    React.createElement($$Default, {
      "class": "_8e04fdd2" + " " + "_2dbb4493__button-preview _pub-2dbb4493__button-preview _pub-a97d53f3__button-preview _button-preview",
      "primary": true,
    }, 
      "Primary"
      
    ),
    React.createElement($$Default, {
      "class": "_f903cd44" + " " + "_2dbb4493__button-preview _pub-2dbb4493__button-preview _pub-a97d53f3__button-preview _button-preview",
      "primary": true,
      "loading": true,
    }, 
      "\n    Primary\n    "
      ,
      React.createElement("Spinner", {
        "className": "_41ed8525 _2dbb4493 _pub-2dbb4493 _pub-a97d53f3",
      }, null)
    ),
    React.createElement($$Default, {
      "class": "_600a9cfe" + " " + "_2dbb4493__button-preview _pub-2dbb4493__button-preview _pub-a97d53f3__button-preview _button-preview",
      "primary": true,
      "outline": true,
    }, 
      "Primary outline"
      
    ),
    React.createElement($$Default, {
      "class": "_170dac68" + " " + "_2dbb4493__button-preview _pub-2dbb4493__button-preview _pub-a97d53f3__button-preview _button-preview",
      "xsmall": true,
    }, 
      "xsmall"
      
    ),
    React.createElement($$Default, {
      "class": "_87b2b1f9" + " " + "_2dbb4493__button-preview _pub-2dbb4493__button-preview _pub-a97d53f3__button-preview _button-preview",
      "small": true,
    }, 
      "Small"
      
    ),
    React.createElement($$Default, {
      "class": "_f0b5816f" + " " + "_2dbb4493__button-preview _pub-2dbb4493__button-preview _pub-a97d53f3__button-preview _button-preview",
      "medium": true,
    }, 
      "Medium"
      
    ),
    React.createElement($$Default, {
      "class": "_e1ff9c61" + " " + "_2dbb4493__button-preview _pub-2dbb4493__button-preview _pub-a97d53f3__button-preview _button-preview",
      "large": true,
    }, 
      "Large"
      
    ),
    React.createElement($$Default, {
      "class": "_96f8acf7" + " " + "_2dbb4493__button-preview _pub-2dbb4493__button-preview _pub-a97d53f3__button-preview _button-preview",
      "wide": true,
    }, 
      "default width 100%"
      
    ),
    React.createElement($$Default, {
      "class": "_ff1fd4d" + " " + "_2dbb4493__button-preview _pub-2dbb4493__button-preview _pub-a97d53f3__button-preview _button-preview",
      "href": "https://captec.io",
    }, 
      "\n    This is a link\n  "
      
    ),
    React.createElement($$Default, {
      "class": "_78f6cddb" + " " + "_2dbb4493__button-preview _pub-2dbb4493__button-preview _pub-a97d53f3__button-preview _button-preview",
      "href": "https://captec.io",
      "disabled": true,
    }, 
      "\n    This is a link\n  "
      
    ),
    React.createElement($$Default, {
      "class": "_e6925878" + " " + "_2dbb4493__button-preview _pub-2dbb4493__button-preview _pub-a97d53f3__button-preview _button-preview",
      "href": "https://captec.io",
      "disabled": true,
      "transparent": true,
    }, 
      "\n    Transparent button\n  "
      
    ),
    React.createElement($$Default, {
      "class": "_919568ee" + " " + "_2dbb4493__button-preview _pub-2dbb4493__button-preview _pub-a97d53f3__button-preview _button-preview",
      "secondary": true,
      "href": "https://captec.io",
      "primary": true,
    }, 
      "\n    Secondary\n  "
      
    ),
    React.createElement("span", {
      "className": "_89c3954 _2dbb4493 _pub-2dbb4493 _pub-a97d53f3",
      "style": castStyle("--primary-color: #F60"),
    }, 
      React.createElement($$Default, {
        "class": "_c6f86078" + " " + "_2dbb4493__button-preview _pub-2dbb4493__button-preview _pub-a97d53f3__button-preview _button-preview",
        "secondary": true,
        "href": "https://captec.io",
        "primary": true,
      }, 
        "\n      Primary color override\n    "
        
      )
    ),
    React.createElement("span", {
      "className": "_7f9b09c2 _2dbb4493 _pub-2dbb4493 _pub-a97d53f3",
      "style": castStyle("--primary-color: #F60"),
    }, 
      React.createElement($$Default, {
        "class": "_c73a0a4f" + " " + "_2dbb4493__button-preview _pub-2dbb4493__button-preview _pub-a97d53f3__button-preview _button-preview",
        "loading": true,
        "secondary": true,
        "outline": true,
        "href": "https://captec.io",
        "primary": true,
      }, 
        "\n      Primary color override\n      "
        ,
        React.createElement("Spinner", {
          "className": "_a71935c4 _2dbb4493 _pub-2dbb4493 _pub-a97d53f3",
        }, null)
      )
    ),
    React.createElement($$Default, {
      "class": "_ef241453" + " " + "_2dbb4493__button-preview _pub-2dbb4493__button-preview _pub-a97d53f3__button-preview _button-preview",
      "secondary": true,
      "negative2": true,
      "transparent": true,
      "href": "https://captec.io",
    }, 
      "\n    transparent negate\n  "
      
    ),
    React.createElement($$Default, {
      "class": "_982324c5" + " " + "_2dbb4493__button-preview _pub-2dbb4493__button-preview _pub-a97d53f3__button-preview _button-preview",
      "secondary": true,
      "negative2": true,
      "transparent": true,
      "href": "https://captec.io",
      "hover": true,
    }, 
      "\n    Hover transparent negate\n  "
      
    ),
    React.createElement("h4", {
      "className": "_cad2cfa2 _2dbb4493 _pub-2dbb4493 _pub-a97d53f3",
    }, 
      "V3"
      
    ),
    React.createElement("div", {
      "className": "_bdd5ff34 _2dbb4493 _pub-2dbb4493 _pub-a97d53f3" + " " + "_2dbb4493_v3 _pub-2dbb4493_v3 _pub-a97d53f3_v3 v3",
    }, 
      React.createElement($$Default, {
        "class": "_d102d913",
        "primary": true,
      }, 
        "regular"
        
      ),
      React.createElement($$Default, {
        "class": "_a605e985",
        "v3": true,
        "primary": true,
        "tooltipText": "Tooltip Text",
      }, 
        "Tooltip"
        
      ),
      React.createElement($$Default, {
        "class": "_3f0cb83f",
        "v3": true,
        "primary": true,
        "hover": true,
      }, 
        "hover"
        
      ),
      React.createElement($$Default, {
        "class": "_480b88a9",
        "v3": true,
        "primary": true,
        "active": true,
      }, 
        "active"
        
      ),
      React.createElement($$Default, {
        "class": "_d66f1d0a",
        "v3": true,
        "primary": true,
        "focus": true,
      }, 
        "focus"
        
      ),
      React.createElement($$Default, {
        "class": "_a1682d9c",
        "v3": true,
        "primary": true,
        "disabled": true,
      }, 
        "disabled"
        
      )
    ),
    React.createElement("br", {
      "className": "_24dcae8e _2dbb4493 _pub-2dbb4493 _pub-a97d53f3",
    }, null),
    React.createElement("br", {
      "className": "_53db9e18 _2dbb4493 _pub-2dbb4493 _pub-a97d53f3",
    }, null),
    React.createElement($$Default, {
      "class": "_cdbf0bbb",
      "v3": true,
      "xsmall": true,
    }, 
      "small"
      
    ),
    React.createElement($$Default, {
      "class": "_bab83b2d",
      "v3": true,
      "small": true,
    }, 
      "small"
      
    ),
    React.createElement($$Default, {
      "class": "_23b16a97",
      "v3": true,
    }, 
      "regular"
      
    ),
    React.createElement($$Default, {
      "class": "_54b65a01",
      "v3": true,
      "large": true,
    }, 
      "large"
      
    ),
    React.createElement("br", {
      "className": "_c4094790 _2dbb4493 _pub-2dbb4493 _pub-a97d53f3",
    }, null),
    React.createElement("br", {
      "className": "_b30e7706 _2dbb4493 _pub-2dbb4493 _pub-a97d53f3",
    }, null),
    React.createElement("div", {
      "className": "_d3c9fee3 _2dbb4493 _pub-2dbb4493 _pub-a97d53f3",
      "style": castStyle("--primary-color: orange;"),
    }, 
      React.createElement($$Default, {
        "class": "_687cd441",
        "v3": true,
        "primary": true,
      }, 
        "branded"
        
      ),
      React.createElement($$Default, {
        "class": "_1f7be4d7",
        "v3": true,
        "primary": true,
        "hover": true,
      }, 
        "hover"
        
      ),
      React.createElement($$Default, {
        "class": "_8672b56d",
        "v3": true,
        "primary": true,
        "active": true,
      }, 
        "active"
        
      ),
      React.createElement($$Default, {
        "class": "_f17585fb",
        "v3": true,
        "primary": true,
        "focus": true,
      }, 
        "focus"
        
      ),
      React.createElement($$Default, {
        "class": "_6f111058",
        "v3": true,
        "primary": true,
        "disabled": true,
      }, 
        "disabled"
        
      )
    ),
    React.createElement("br", {
      "className": "_a4cece75 _2dbb4493 _pub-2dbb4493 _pub-a97d53f3",
    }, null),
    React.createElement($$Default, {
      "class": "_3dc79fcf",
      "v3": true,
    }, 
      "regular"
      
    ),
    React.createElement($$Default, {
      "class": "_4ac0af59",
      "v3": true,
      "hover": true,
    }, 
      "hover"
      
    ),
    React.createElement($$Default, {
      "class": "_d4a43afa",
      "v3": true,
      "active": true,
    }, 
      "active"
      
    ),
    React.createElement($$Default, {
      "class": "_a3a30a6c",
      "v3": true,
      "focus": true,
    }, 
      "focus"
      
    ),
    React.createElement($$Default, {
      "class": "_3aaa5bd6",
      "v3": true,
      "disabled": true,
    }, 
      "disabled"
      
    ),
    React.createElement("br", {
      "className": "_4dad6b40 _2dbb4493 _pub-2dbb4493 _pub-a97d53f3",
    }, null),
    React.createElement("br", {
      "className": "_dd1276d1 _2dbb4493 _pub-2dbb4493 _pub-a97d53f3",
    }, null),
    React.createElement($$Default, {
      "class": "_aa154647",
      "v3": true,
      "negative": true,
    }, 
      "negative"
      
    ),
    React.createElement($$Default, {
      "class": "_9c886824",
      "v3": true,
      "negative": true,
      "hover": true,
    }, 
      "negative"
      
    ),
    React.createElement($$Default, {
      "class": "_eb8f58b2",
      "v3": true,
      "negative": true,
      "active": true,
    }, 
      "negative"
      
    ),
    React.createElement($$Default, {
      "class": "_72860908",
      "v3": true,
      "negative": true,
      "focus": true,
    }, 
      "negative"
      
    ),
    React.createElement($$Default, {
      "class": "_581399e",
      "v3": true,
      "negative": true,
      "disabled": true,
    }, 
      "negative"
      
    ),
    React.createElement("br", {
      "className": "_9be5ac3d _2dbb4493 _pub-2dbb4493 _pub-a97d53f3",
    }, null),
    React.createElement("br", {
      "className": "_ece29cab _2dbb4493 _pub-2dbb4493 _pub-a97d53f3",
    }, null),
    React.createElement($$Default, {
      "class": "_75ebcd11",
      "v3": true,
      "transparent": true,
    }, 
      "regular"
      
    ),
    React.createElement($$Default, {
      "class": "_2ecfd87",
      "v3": true,
      "transparent": true,
      "hover": true,
    }, 
      "hover"
      
    ),
    React.createElement($$Default, {
      "class": "_9253e016",
      "v3": true,
      "transparent": true,
      "active": true,
    }, 
      "active"
      
    ),
    React.createElement($$Default, {
      "class": "_e554d080",
      "v3": true,
      "transparent": true,
      "focus": true,
    }, 
      "focus"
      
    ),
    React.createElement($$Default, {
      "class": "_85935965",
      "v3": true,
      "transparent": true,
      "disabled": true,
    }, 
      "disabled"
      
    ),
    React.createElement("br", {
      "className": "_f29469f3 _2dbb4493 _pub-2dbb4493 _pub-a97d53f3",
    }, null),
    React.createElement("br", {
      "className": "_6b9d3849 _2dbb4493 _pub-2dbb4493 _pub-a97d53f3",
    }, null),
    React.createElement($$Default, {
      "class": "_1c9a08df",
      "v3": true,
      "transparent": true,
      "negative": true,
    }, 
      "regular"
      
    ),
    React.createElement($$Default, {
      "class": "_82fe9d7c",
      "v3": true,
      "transparent": true,
      "negative": true,
      "hover": true,
    }, 
      "hover"
      
    ),
    React.createElement($$Default, {
      "class": "_f5f9adea",
      "v3": true,
      "transparent": true,
      "negative": true,
      "active": true,
    }, 
      "active"
      
    ),
    React.createElement($$Default, {
      "class": "_6cf0fc50",
      "v3": true,
      "transparent": true,
      "negative": true,
      "focus": true,
    }, 
      "focus"
      
    ),
    React.createElement($$Default, {
      "class": "_1bf7ccc6",
      "v3": true,
      "transparent": true,
      "negative": true,
      "disabled": true,
    }, 
      "disabled"
      
    )
  )
}));
export { defaultsPreview };


